module.exports = __webpack_public_path__ + "img/img3.88061d43.jpg";